var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPdfNewIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 22.5C3.45 22.5 2.97917 22.3042 2.5875 21.9125C2.19583 21.5208 2 21.05 2 20.5V4.5C2 3.95 2.19583 3.47917 2.5875 3.0875C2.97917 2.69583 3.45 2.5 4 2.5H12L18 8.5V12.75H16V9.5H11V4.5H4V20.5H15V22.5H4ZM20 22.5L16 18.5L17.4 17.075L19 18.65V14.5H21V18.65L22.6 17.075L24 18.5L20 22.5Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18H6V16H7C7.28333 16 7.52083 15.9042 7.7125 15.7125C7.90417 15.5208 8 15.2833 8 15V14C8 13.7167 7.90417 13.4792 7.7125 13.2875C7.52083 13.0958 7.28333 13 7 13H5V18ZM11 18C11.2833 18 11.5208 17.9042 11.7125 17.7125C11.9042 17.5208 12 17.2833 12 17V14C12 13.7167 11.9042 13.4792 11.7125 13.2875C11.5208 13.0958 11.2833 13 11 13H9V18H11ZM14 18H13V13H15V14H14V15H15V16H14V18ZM10 14H11V17H10V14ZM7 14H6V15H7V14Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdfNewIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf-new-icon.b01a8d8d.svg";
export { ForwardRef as ReactComponent };